'use client';

import type {FormEvent} from 'react';
import {type FC, useCallback, useId, useState} from 'react';
import clsx from 'clsx';
import {useRouter} from 'next/navigation';

import {buttonClasses} from '@/components/button';
import {SearchIcon} from '@/components/icons/search';
import {searchInputClasses} from '@/components/input';
import {i18n} from '@/utils/i18n';

export const ErrorForm: FC = () => {
	const id = useId();
	const [value, setValue] = useState('');
	const router = useRouter();

	const handleSubmit = useCallback(
		(event: FormEvent<HTMLFormElement>) => {
			event.preventDefault();
			router.push(`/sok?q=${new URLSearchParams({q: value}).get('q')}`);
		},
		[router, value],
	);

	return (
		<form
			className={clsx('flex', 'gap-10', 'mr-10')}
			onSubmit={handleSubmit}
		>
			{}
			<label
				className={clsx(
					'flex-1',
					'relative',
					'block',
					'w-full',
					'transition-all',
					'duration-200',
					'text-forestGreen-700',
				)}
			>
				<input
					id={id}
					type="text"
					name="q"
					placeholder={i18n.components.search.placeholderNotFound}
					value={value}
					onChange={(event) =>
						setValue && setValue(event.target.value)
					}
					className={clsx(searchInputClasses)}
				/>
				<div
					className={clsx(
						'absolute',
						'h-full',
						'aspect-square',
						'p-3',
						'top-0',
						'left-2',
					)}
				>
					<SearchIcon />
				</div>
			</label>

			<button
				type="submit"
				className={clsx(
					buttonClasses,
					'text-beige-500',
					'rounded-lg',
					'!text-base',
					'!font-medium',
					'!h-12',
					'!px-10',
				)}
			>
				{i18n.components.search.buttonNotFound}
			</button>
		</form>
	);
};
